import VueRouter, { RouteConfig } from 'vue-router'
import { ExamRecordStandardDetailsTab } from 'kuaidong-model'

const List = () => import('../views/exam-record-standard/List.vue')
const Details = () => import('../views/exam-record-standard/Details.vue')

export const listRoute: RouteConfig = {
  path: 'record-standard-list',
  name: 'exam_record_standard_list',
  component: List,
  meta: {
    title: '分析报告',
  },
}

export const detailsRoute: RouteConfig = {
  path: 'record-standard-details',
  name: 'exam_record_standard_details',
  component: Details,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '分析报告',
  },
}

export default [listRoute, detailsRoute]

export function navigateToExamRecordStandardList(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToExamRecordStandardDetails(
  router: VueRouter,
  id: string,
  tab = ExamRecordStandardDetailsTab.Measure
) {
  router.push({ name: detailsRoute.name, query: { id, tab } })
}
